import { env } from "../../../../config";

export const gtmId = env.analytics.gtmId;
